import type { AgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";
import type { AgentUiNodeKind } from "src/components/views/ai/assistant/uiContext/agentUiNodeTypes.ts";

interface AgentUiSizeWarningContext {
	kind: AgentUiNodeKind;
	key: AgentUiContextKey | null;
}

export function warnIfLarge(
	label: string,
	value: unknown,
	maxCharacters: number,
	context: AgentUiSizeWarningContext,
) {
	try {
		const serializedLength = JSON.stringify(value).length;
		if (serializedLength > maxCharacters) {
			console.warn(`${label} is large`, {
				kind: context.kind,
				key: context.key,
				serializedCharacters: serializedLength,
				warningThresholdCharacters: maxCharacters,
			});
		}
	} catch {
		console.warn(`${label} could not be serialized to JSON`);
	}
}
